import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { TaxesStore as Store } from "../../store";
import MaskedField from "../UI/Fields/MaskedField";
import DialogModal from "../UI/DialogModals/DialogModal";
import useValidations from "../../hooks/useValidations";
import { lang } from "../../i18nLang";

interface IProps {
  /** Propriedade que indica se o modal está aberto ou fechado. */
  open: boolean;
  /** Função que será chamada ao fechar o modal */
  onClose: Function;
}

/** Aréa do registro dos impostos.
 * @category Components
 */
const Taxes = observer((props: IProps) => {
  const { validated, validateFields, hasErrors } = useValidations(
    Store.validations
  );
  const fields = Store.fields;

  useEffect(() => {
    Store.reloadFields();
  }, [props.open]);

  const handleClose = (ev) => {
    if (ev.type === "click") props.onClose();
  };

  const handleChangeField = (ev) => {
    Store.setFields(ev.target.name, ev.target.value);
  };

  const handleBlurField = (ev, value) => {
    const name = ev.target.name;
    validateFields({ [name]: value });
  };

  const handleConfirm = async (ev) => {
    const success = await Store.updateTaxes();
    return !success;
  };

  return (
    <DialogModal
      title={lang("taxes.title")}
      open={props.open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      confirmLabel={lang("save")}
      disabledConfirm={hasErrors()}
    >
      <MaskedField
        name="inss"
        label={lang("taxes.fields.inss")}
        suffix="%"
        decimalScale={2}
        allowNegative={false}
        value={fields?.inss}
        onChange={handleChangeField}
        onBlur={handleBlurField}
        onKeyDown={(ev) => ev.stopPropagation()}
        error={!validated.inss.valid}
        helperText={validated.inss.text}
        margin="normal"
        fullWidth
      />
      <MaskedField
        name="iss"
        label={lang("taxes.fields.iss")}
        suffix="%"
        decimalScale={2}
        allowNegative={false}
        value={fields?.iss}
        onChange={handleChangeField}
        onBlur={handleBlurField}
        onKeyDown={(ev) => ev.stopPropagation()}
        error={!validated.iss.valid}
        helperText={validated.iss.text}
        margin="normal"
        fullWidth
      />
      <MaskedField
        name="pis"
        label={lang("taxes.fields.pis")}
        suffix="%"
        decimalScale={2}
        allowNegative={false}
        value={fields?.pis}
        onChange={handleChangeField}
        onBlur={handleBlurField}
        onKeyDown={(ev) => ev.stopPropagation()}
        error={!validated.pis.valid}
        helperText={validated.pis.text}
        margin="normal"
        fullWidth
      />
      <MaskedField
        name="cofins"
        label={lang("taxes.fields.cofins")}
        suffix="%"
        decimalScale={2}
        allowNegative={false}
        value={fields?.cofins}
        onChange={handleChangeField}
        onBlur={handleBlurField}
        onKeyDown={(ev) => ev.stopPropagation()}
        error={!validated.cofins.valid}
        helperText={validated.cofins.text}
        margin="normal"
        fullWidth
      />
      <MaskedField
        name="csll"
        label={lang("taxes.fields.csll")}
        suffix="%"
        decimalScale={2}
        allowNegative={false}
        value={fields?.csll}
        onChange={handleChangeField}
        onBlur={handleBlurField}
        onKeyDown={(ev) => ev.stopPropagation()}
        error={!validated.csll.valid}
        helperText={validated.csll.text}
        margin="normal"
        fullWidth
      />
    </DialogModal>
  );
});

export default Taxes;
